import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IRow } from '../../_shared/models/table/row.model';

import { HeadingComponent } from '../../heading/heading.component';

@Component({
    selector: 'sirius-table-regular',
    templateUrl: './table-regular.component.html',
    styleUrls: ['../table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [HeadingComponent]
})
export class TableRegularComponent {
    @Input() rows!: IRow[];
    @Input() title!: string;
    @Input() columnsNumber!: number;
}
